/* eslint-disable import/no-default-export, import/order, max-lines, max-lines-per-function, no-nested-ternary, react/no-unescaped-entities, react/prop-types */
import "./RemoveBackground.scss";
import { cn } from "tailwind-variants";

export default function RemoveBackground({ value, disabled, onChange, ...restProps }: any) {
  const { className: restClassName, ...otherAttrs } = restProps;

  return (
    <div className={cn("scope-25a8c6e5", "remove-background", restClassName)} {...otherAttrs}>
      <label
        className="remove-background__container scope-25a8c6e5"
        data-testid="remove-background-container"
      >
        <div className="remove-background__switch scope-25a8c6e5">
          <input
            className="remove-background__input scope-25a8c6e5"
            type="checkbox"
            checked={value}
            disabled={disabled}
            readOnly
            onClick={e => {
              e.preventDefault();
              onChange(!value);
            }}
            data-testid="remove-background-input"
          />
          <span className="remove-background__slider scope-25a8c6e5" />
        </div>
        <div className="remove-background__label scope-25a8c6e5">
          <span className="scope-25a8c6e5">Remove Background</span>
        </div>
      </label>
    </div>
  );
}
